import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { House, ClipboardText, Users, ChartBar, SignOut, UserCircle, Fire } from '@phosphor-icons/react';

export const Sidebar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: House, roles: ['admin', 'reception', 'technician'] },
    { path: '/orders', label: 'Órdenes', icon: ClipboardText, roles: ['admin', 'reception', 'technician', 'client'] },
    { path: '/clients', label: 'Clientes', icon: Users, roles: ['admin', 'reception'] },
    { path: '/users', label: 'Usuarios', icon: UserCircle, roles: ['admin'] },
    { path: '/statistics', label: 'Estadísticas', icon: ChartBar, roles: ['admin'] },
  ];

  const filteredMenuItems = menuItems.filter(item => item.roles.includes(user?.role));

  return (
    <div className="fixed left-0 top-0 h-screen w-64 bg-white border-r border-border flex flex-col">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-center">
          <img src="/sigal-logo.png" alt="SIGAL EXTINTORES" className="h-12" />
        </div>
      </div>

      <nav className="flex-1 p-4 space-y-1">
        {filteredMenuItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`nav-${item.path.substring(1)}`}
              className={`flex items-center gap-3 px-4 py-3 text-sm font-medium border transition-colors ${
                active 
                  ? 'bg-primary text-primary-foreground border-transparent hover:bg-primary/90' 
                  : 'text-foreground border-transparent hover:border-border hover:bg-secondary/50'
              }`}
            >
              <Icon size={20} weight={active ? 'fill' : 'regular'} />
              {item.label}
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-border">
        <div className="mb-3 px-2">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">Usuario</p>
          <p className="text-sm font-semibold mt-1">{user?.name}</p>
          <p className="text-xs text-muted-foreground mt-0.5">{user?.role}</p>
        </div>
        <button
          onClick={logout}
          data-testid="logout-button"
          className="flex items-center gap-3 w-full px-4 py-3 text-sm font-medium text-destructive border border-border hover:bg-destructive hover:text-destructive-foreground"
        >
          <SignOut size={20} />
          Cerrar Sesión
        </button>
      </div>
    </div>
  );
};
